<template>
  <base-draggable-modal
      :name="relation_page.name"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.display.xsOnly"
      :ref="relation_page.name">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(relation_page.name) }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-data-table
                :headers="fields"
                :items="getRecords"
                class="elevation-1"
                item-value="id"
                selectable-key="id"
                return-object
                show-select
                v-model="selected"
                v-bind="footer_props"
                v-model:items-per-page="options.itemsPerPage"
                v-model:page="options.page">
              <template #body.prepend>
                <tr>
                  <td/><!--EMPTY TD FOR CHECKBOXES-->
                  <td v-for="(key, index) in Object.keys(response_fields)" :key="index">
                    <base-field-in-table-header :advanced_search="advanced_search" :field_name="key" :field_type="response_fields[key]" :page_name="relation_page.name" @showRecords="showRecords" @clearSearch="clearSearch"/>
                  </td>
                </tr>
              </template>
              <template #body="{ items }">
                <tr v-for="item in items" :key="item.id" class="sm-normal text-primary">
                  <td>
                    <v-checkbox color="success" density="compact" v-model="selected" :key="item.id" :value="item"/>
                  </td>
                  <td v-for="(key, index) in Object.keys(response_fields)" :key="index" @click.exact="addToSelect(item)">
                    <base-field-in-table :item="item" :field_name="key" :field_type="response_fields[key]" :page_name="relation_page.name"/>
                  </td>
                </tr>
                <tr v-if="getRecords.length === 0">
                  <td :colspan="fields.length + 1" class="text-center">
                    <span class="sm-normal link">{{ $store.getters.translate("nothing_found") }}</span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("close") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import {useAbility} from "@casl/vue";
import helpFunctions from "../../plugins/helpFunctions.js";
import BaseFieldInTable from "./BaseFieldInTable";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseFieldInTableHeader from "./BaseFieldInTableHeader";
import BaseActionButton from "./BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  components: { BaseActionButton, BaseFieldInTableHeader, BaseFieldInTable, BaseDraggableModal, BaseModal, PhFloppyDisk, PhX },
  props: ["relation_page", "excluded_ids"],
  setup() {
    const { can } = new useAbility();
    return { can }
  },
  data() {
    return {
      records: [],
      selected: [],
      all_records: [],
      options: helpFunctions.table_options,
      footer_props: helpFunctions.footer_props,
      advanced_search: {
        tags_array: [],
      },
      response_fields: {},
      fields: [],
      //USED IN CANDIDATES INCLUDABLE TABLE ON EDIT CONTACTS PAGE TO LINK CORRECT CANDIDATES TO CONTACTS
      companies: null,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal(this.relation_page.name);
      let additional_filter = this.companies ? "&company_ids=" + this.$lodash.map(this.companies, 'id') : '';
      let response = await helpFunctions.getModelsForTables(this.$toast, this.relation_page.name, additional_filter);
      this.all_records = response.data;
      this.response_fields = helpFunctions.replaceIDwithNameBaseTable(response.fields);
      this.fields = helpFunctions.composeFields(this.response_fields, false);
      if (this.excluded_ids) {
        this.all_records = this.all_records.filter((record) => !this.excluded_ids.includes(record.id));
      }
      this.showRecords();
    },
    save() {
      this.$emit('linkOrCreateRecord', this.selected);
      this.reset();
    },
    addToSelect(item) {
      if (!this.selected.includes(item)) {
        this.selected.push(item);
      }
      this.save();
    },
    showRecords() {
      this.records = helpFunctions.showRecords(this.all_records, this.response_fields, this.advanced_search);
    },
    clearSearch(key) {
      this.advanced_search[key] = null;
      this.showRecords();
    },
    reset() {
      this.closeModal(this.relation_page.name);
      this.records = [];
      this.all_records = [];
      this.selected = [];
    },
  },
  computed: {
    getRecords() {
      if(this.records) {
        return this.records;
      }
      else {
        return [];
      }
    },
  },
  watch: {
    options: {
      handler() {
        if (this.all_records && this.all_records.length > 0) {
          this.showRecords();
        }
      },
      deep: true,
    },
    advanced_search: {
      handler() {
        this.options.page = 1;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.v-checkbox {
  display: flex;
}
.v-text-field >>> input {
  font-size: 12px !important;
}
.v-text-field >>> label {
  font-size: 12px !important;
}
</style>